import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ANIM_PANE_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';

export const config = {
    id: ActionType.ANIM_PANE,
    icon: ANIM_PANE_ICON,
    content: i18n.t('动画窗格'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.content,
    },
];
